import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { client } from "../../lib/client";
import { LogOut, Shield, User, Bell } from "lucide-react";
import { PRODUCT } from "../../lib/productConfig";
import { EnterpriseSearch } from "./EnterpriseSearch";
import { useNavigate } from "react-router-dom";

export function Header() {
  const { user, apiClient } = useAuth();
  const navigate = useNavigate();

  // BUG FIX: this used to hardcode two admin emails to decide the badge —
  // the same broken pattern Sidebar.tsx had — so every other account, real
  // Super Admins created through the normal Add New User flow included,
  // showed a plain "User" badge here. Pulls the real system_role from
  // /api/me (already used elsewhere) instead.
  const [systemRole, setSystemRole] = useState<string | null>(null);
  useEffect(() => {
    if (!apiClient || !user) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await apiClient("/api/me");
        if (!cancelled) setSystemRole(res?.data?.systemRole || null);
      } catch {
        if (!cancelled) setSystemRole(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [apiClient, user]);

  const handleSignOut = async () => {
    await client.auth.signOut();
    window.location.reload();
  };

  const displayName = user?.name || user?.email?.split("@")[0] || "User";
  const isSuperAdmin = systemRole === "Super Admin" || systemRole === "Executive Admin";
  const roleLabel = systemRole || "User";

  return (
    <header className="flex h-14 items-center justify-between border-b border-gray-200 bg-white px-4 shadow-sm">
      <div className="flex items-center gap-3">
        <h2 className="text-sm font-semibold text-gray-800 hidden lg:block">{PRODUCT.name}</h2>
        <span className="hidden xl:inline-flex items-center px-2 py-0.5 rounded text-[10px] font-semibold bg-blue-50 text-blue-700 border border-blue-200">
          {PRODUCT.edition} — {PRODUCT.fullVersion}
        </span>
      </div>

      <div className="flex items-center gap-3">
        {/* Enterprise Search */}
        <EnterpriseSearch />

        {/* Notifications */}
        <button
          onClick={() => navigate("/mission-control/notifications")}
          className="relative p-2 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors"
          title="Notifications"
        >
          <Bell className="h-5 w-5" />
          <span className="absolute top-1 right-1 h-2 w-2 bg-red-500 rounded-full" />
        </button>

        {/* User Menu */}
        <div className="flex items-center gap-2 text-sm text-gray-600">
          {isSuperAdmin ? (
            <Shield className="h-4 w-4 text-purple-600" />
          ) : (
            <User className="h-4 w-4" />
          )}
          <div className="hidden sm:flex flex-col items-end leading-tight">
            <span className="font-medium text-gray-900 text-xs">{displayName}</span>
            <span className={`text-[10px] font-semibold ${isSuperAdmin ? "text-purple-600" : "text-gray-400"}`}>
              {roleLabel}
            </span>
          </div>
        </div>

        <button
          onClick={handleSignOut}
          className="flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors"
        >
          <LogOut className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">Sign Out</span>
        </button>
      </div>
    </header>
  );
}
